import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { feeTemplateService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type MutationProps = {
	companyId: string;
	templateId: string;
	mappedData: { [key: string]: any };
};

const useEditAriseFeeTemplateMutation = (onSuccess?: Function) => {
	const dispatch = useDispatch();

	return useMutation(
		({ companyId, templateId, mappedData }: MutationProps) => {
			return feeTemplateService.ariseFeeTemplateEdit({
				companyId,
				templateId,
				data: mappedData,
			});
		},
		{
			onSuccess() {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useEditAriseFeeTemplateMutation;
